var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: _vm.computedClasses },
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.mutableValue,
            expression: "mutableValue",
            modifiers: { trim: true },
          },
        ],
        ref: "textarea",
        staticClass: "form-control city-textarea",
        class: [{ "no-resize": _vm.noResize }, _vm.inputClasses],
        attrs: {
          disabled: _vm.disabled,
          readonly: _vm.readonly,
          rows: _vm.rows,
          id: _vm.id,
          name: _vm.name,
        },
        domProps: { value: _vm.mutableValue },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.mutableValue = $event.target.value.trim()
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "material-label",
          class: { active: _vm.mutableValue },
          attrs: { for: _vm.id },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.error
        ? _c("small", { staticClass: "invalid-feedback" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("help-span", { attrs: { helpText: _vm.helpText } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }